let linkActiveClass = "active";

export default {
  loginRoute: { name: "auth" },
  requiresGuestRedirect: "/",
  requiresUserRedirect: "/user/login",
  linkActiveClass: linkActiveClass,
};
